import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { TemperatureReadings_ShellService } from './TemperatureReadings.shell.service';
import { TemperatureReadings_OperationService } from './TemperatureReadings.operation.service';
import { TemperatureReadings_DatasourceService } from './TemperatureReadings.datasource.index';
import { TemperatureReadings_FlowService } from './TemperatureReadings.flow.index';
import { TemperatureReadings_ReportService } from './TemperatureReadings.report.index';
import { TemperatureReadings_LocalizationService } from './TemperatureReadings.localization.service';
import { TemperatureReadings_shipment_lines_ComponentContextService } from './TemperatureReadings.shipment_lines.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './TemperatureReadings.frontend.types'
import { $frontendTypes as $types} from './TemperatureReadings.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'TemperatureReadings-shipment_lines_single',
  templateUrl: './TemperatureReadings.shipment_lines_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TemperatureReadings_shipment_lines_singleComponent),
      multi: true
    }
  ]
})
export class TemperatureReadings_shipment_lines_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }


  inParams: { shipmentId?: number } = { shipmentId: null };
  @Input('shipmentId') set $inParams_shipmentId(value: any) {
    this.inParams['shipmentId'] = value;
  }
  get $inParams_shipmentId(): any {
    return this.inParams['shipmentId'] ;
  }

  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: TemperatureReadings_ShellService,
    private $datasources: TemperatureReadings_DatasourceService,
    private $flows: TemperatureReadings_FlowService,
    private $reports: TemperatureReadings_ReportService,
    private $localization: TemperatureReadings_LocalizationService,
    private $operations: TemperatureReadings_OperationService,
    private $logger: CleanupLoggerService,
    private $context: TemperatureReadings_shipment_lines_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): number | number[] {
    return this._innerValue;
  }

  set value(val: number | number[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }



  displayWithFn(value: any): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.$datasources.TemperatureReadings.ds_shipment_lines_dd.getByKeys({
        $keys: [value],
        shipmentId:  $selector.inParams.shipmentId ,
        fullTextSearch:  $selector.fullTextSearch ,
      }).then(result => {
        const found = result.result[0];
        const e: { Id?: number, LineNumber?: number, ShipmentId?: number, OrderLine?: { LineNumber?: number, Material?: { LookupCode?: string }, Order?: { LookupCode?: string } }, Shipment?: { LookupCode?: string } } = found ?? {};
        const $option = { entity: e };
         const $entity = e;
        const displayTextResult = found ? ('Line: ' + $option.entity.LineNumber.toString() + ' - Order: ' + $option.entity.OrderLine.Order.LookupCode + ' - Material: ' + $option.entity.OrderLine.Material.LookupCode) : 'No data to display';
        this.displayTextChange.emit(displayTextResult);
        resolve(displayTextResult);
      });

    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.$datasources.TemperatureReadings.ds_shipment_lines_dd.getList({
        $top: 15,
        $skip: 0,
        shipmentId:  $selector.inParams.shipmentId ,
        fullTextSearch:  $selector.fullTextSearch ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: 'Line: ' + $option.entity.LineNumber.toString() + ' - Order: ' + $option.entity.OrderLine.Order.LookupCode + ' - Material: ' + $option.entity.OrderLine.Material.LookupCode, disabled: null };
            $resultOption.key = $option.entity.Id;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 15
        });
      });

    });

    return promise;

  }

}
